import { AdditionalIncomeAdditionalFieldsNames } from '../../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'
import { IncomeAdditionalFieldsNames } from '../../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { TAllAdditionalFieldsNames, TAllBasedFieldsNames, FormNames, AdditionalFormNames } from '../../models/form/IFormDefinition'
import { IFieldsDataStateFieldValue } from '../types'

export const SET_SINGLE_FIELD_VALUE = 'SET_SINGLE_FIELD_VALUE';
export const SET_SINGLE_FIELD_VALIDATION_ERROR = 'SET_SINGLE_FIELD_VALIDATION_ERROR';
export const CHANGE_INCOME_INFO_FIELDS = 'CHANGE_INCOME_INFO_FIELDS';
export const CHANGE_ADDITIONAL_INCOME_INFO_FIELDS = 'CHANGE_ADDITIONAL_INCOME_INFO_FIELDS';
export const TOGGLE_FIELD_ON_BOOLEAN_CHANGE = 'TOGGLE_FIELD_ON_BOOLEAN_CHANGE';
export const TOGGLE_ADDITIONAL_FROM = 'TOGGLE_ADDITIONAL_FROM'
export const CLEAR_FIELD_VALIDATION_ERROR = 'CLEAR_FIELD_VALIDATION_ERROR'


export enum ToggleFieldOnBooleanChangeActionType {
  'ADD_FIELD',
  'DELETE_FIELD'
}


export interface ISaveCurrentFieldValue {
  type: typeof SET_SINGLE_FIELD_VALUE;
  payload: {
    formName: FormNames;
    fieldName: TAllBasedFieldsNames;
    newFieldState: IFieldsDataStateFieldValue
    newFieldValue: string;
  }
}

export interface ISetCurrentFieldValidateError {
  type: typeof SET_SINGLE_FIELD_VALIDATION_ERROR;
  payload: {
    formName: FormNames;
    fieldName: TAllBasedFieldsNames;
    newValidationError: string;
  }
}

export interface IChangeIncomeInfoFields {
  type: typeof CHANGE_INCOME_INFO_FIELDS;
  payload: IncomeAdditionalFieldsNames[];
}
export interface IChangeAdditionalIncomeInfoFields {
  type: typeof CHANGE_ADDITIONAL_INCOME_INFO_FIELDS;
  payload: AdditionalIncomeAdditionalFieldsNames[];
}

export interface IToggleFieldOnBooleanChange {
  type: typeof TOGGLE_FIELD_ON_BOOLEAN_CHANGE,
  payload: {
    formName: FormNames.IncomeInfoForm | AdditionalFormNames.AdditionalIncomeForm;
    actionType: ToggleFieldOnBooleanChangeActionType;
    associatedFieldName: IncomeAdditionalFieldsNames | AdditionalIncomeAdditionalFieldsNames;
  } 
}

export interface IToggleAdditionalFormOpen {
  type: typeof TOGGLE_ADDITIONAL_FROM,
  payload: {
    formName: AdditionalFormNames;
    isAdditionalFormOpen: boolean;
    additionalFieldsNamesToAdd: TAllAdditionalFieldsNames[];
  } 
}
export interface IClearFieldValidationError {
  type: typeof CLEAR_FIELD_VALIDATION_ERROR,
  payload: {
    formName: FormNames;
    fieldName: TAllBasedFieldsNames;
  } 
}

export type FormActions = 
  | ISaveCurrentFieldValue
  | ISetCurrentFieldValidateError
  | IChangeIncomeInfoFields
  | IChangeAdditionalIncomeInfoFields
  | IToggleFieldOnBooleanChange
  | IToggleAdditionalFormOpen
  | IClearFieldValidationError